import React from 'react';
import { Breadcrumb } from 'src/app/slice';
import { getBreadcrumbLabel } from './breadcrumbsHelper';
import { StyledLink, StyledTextButton } from './style';
import { LaunchFlag } from 'src/commons/components/LaunchFlag/LaunchFlag';
import { breadcrumbTwinAttributes } from './semantics';
import { useLinkUpdater } from 'src/commons/utils/linkUpdater';

export const LinkBreadcrumb: React.FC<{ breadcrumb: Breadcrumb }> = ({
  breadcrumb,
}) => {
  const transformUrl = useLinkUpdater();

  if (breadcrumb.onClickCallback) {
    return (
      <StyledTextButton
        onClick={breadcrumb.onClickCallback}
        {...breadcrumbTwinAttributes(`button-breadcrumb`, {
          label: breadcrumb.label,
        })}
      >
        {getBreadcrumbLabel(breadcrumb)}
        {!!breadcrumb.objectSuffix && (
          <LaunchFlag flag={{ type: 'beta', label: breadcrumb.objectSuffix }} />
        )}
      </StyledTextButton>
    );
  }

  const resolvedUrl =
    breadcrumb.url && transformUrl
      ? transformUrl(breadcrumb.url)
      : breadcrumb.url;

  return (
    <StyledLink
      href={resolvedUrl}
      {...breadcrumbTwinAttributes(
        `link-breadcrumb`,
        resolvedUrl ? { url: resolvedUrl, label: breadcrumb.label } : {},
      )}
    >
      {getBreadcrumbLabel(breadcrumb)}
      {!!breadcrumb.objectSuffix && (
        <LaunchFlag flag={{ type: 'beta', label: breadcrumb.objectSuffix }} />
      )}
    </StyledLink>
  );
};
